import React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

import type { ExternalUserSortDir, ExternalUserSortKey } from '@/types/external-users.types';
import { classNames } from '@/utils/classNames.utils';

interface SortIndicatorProps {
  activeKey: ExternalUserSortKey;
  column: ExternalUserSortKey;
  direction: ExternalUserSortDir;
}

function SortIndicator({
  activeKey,
  column,
  direction,
}: SortIndicatorProps): React.ReactElement | null {
  if (activeKey !== column) return null;

  return direction === 'asc' ? (
    <ArrowUp className="ml-1 h-3 w-3" />
  ) : (
    <ArrowDown className="ml-1 h-3 w-3" />
  );
}

interface HeaderColumn {
  key: ExternalUserSortKey;
  label: string;
  spanClassName: string;
}

const HEADER_COLUMNS: HeaderColumn[] = [
  { key: 'name', label: 'Name', spanClassName: 'col-span-3' },
  { key: 'email', label: 'Email', spanClassName: 'col-span-3' },
  { key: 'phone', label: 'Phone', spanClassName: 'col-span-2' },
  { key: 'deptOrg', label: 'Dept / Org', spanClassName: 'col-span-2' },
  { key: 'status', label: 'Status', spanClassName: 'col-span-2' },
  { key: 'createdByAccount', label: 'Invited by', spanClassName: 'col-span-2' },
  { key: 'sixCount', label: 'SIXs', spanClassName: 'col-span-1' },
];

interface ExternalUsersTableHeaderProps {
  sortKey: ExternalUserSortKey;
  sortDir: ExternalUserSortDir;
  onSort: (column: ExternalUserSortKey) => void;
}

function ExternalUsersTableHeader({
  sortKey,
  sortDir,
  onSort,
}: ExternalUsersTableHeaderProps): React.ReactElement {
  return (
    <div className="hidden md:grid grid-cols-16 gap-3 border-b border-border bg-muted/40 px-4 py-3 text-sm font-medium text-foreground">
      {HEADER_COLUMNS.map((column) => (
        <button
          key={column.key}
          type="button"
          className={classNames('flex items-center text-left', column.spanClassName)}
          onClick={() => {
            onSort(column.key);
          }}
        >
          {column.label}
          <SortIndicator activeKey={sortKey} column={column.key} direction={sortDir} />
        </button>
      ))}
      <div className="col-span-1 text-right">Actions</div>
    </div>
  );
}

export default ExternalUsersTableHeader;
